module.exports = __webpack_public_path__ + "static/media/sprite_next.4f40e260.png";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/images/default/sprite_next.png
// module id = ./src/CSS/assets-minified/images/default/sprite_next.png
// module chunks = 0